'use strict';
export class PasswordEditorSettings {
  public static PASSWORD_PLACE_HOLDER: string = '*************';
  public static PASSWORD_FIELD_NAME: string = 'password';
}

export enum PasswordEditorMode {
  Encrypt = 'Encrypt',
  Decrypt = 'Decrypt'
}
